import ReactDOM from "react-dom";
import React from "react";
import "./styles.css";
import App from "./App";

export default App;
